import React from "react";
import { Typography } from "antd";

const DurationCell = ({ seconds, isExceeded = false }) => {
  if (!seconds || seconds <= 0) {
    return <span className="duration-cell">-</span>;
  }

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  let timeString = "";
  if (hours >= 24) {
    const days = Math.floor(hours / 24);
    const remainingHours = hours % 24;
    timeString = `${days}d ${remainingHours}h ${minutes}m`;
  } else {
    timeString = hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
  }

  return (
    <Typography.Text
      className="duration-cell"
      type={isExceeded ? "danger" : undefined}
      strong={isExceeded}
    >
      {timeString}
    </Typography.Text>
  );
};

export default DurationCell;
